module.exports = __webpack_public_path__ + "static/media/popsiclesticks.c04f2e33.gif";